export { default } from './Icon'
export * from './Icon'



// WEBPACK FOOTER //
// ./src/components/Icon/index.ts